/**
 * The energy types requested from the server: EnergyInfo.Types. In a module of its own, with no
 * imports, so the Gibbs registry's preconditions can name them and still be bundled without the
 * app (the orchestrator bundles the registry).
 */
export const EnergyTypes = {
    vdW: 'vdW',
    hbonds: 'hbonds',
    ddGs: 'ddGs',
    stress: 'stress',
    electrostatics: 'electrostatics',
    coulomb: 'coulomb',
};
